export enum LocalStorageType {
	User = 'user',
	InterviewResentTimes = 'interviewResentTimes',
	PaidInvoiceIds = 'paidInvoiceIds',
	PaidCreditIds = 'paidCreditIds',
}
